import { MODULES } from 'config/env';
import { defaultLocale } from 'locales/i18n';
import { getItem } from 'util/localStorage';

export const THEME_KEY = 'UTILIHIVE:THEME';
const DEFAULT_THEME = 'dark';

export const deriveConfiguration = data => {
  const userConfiguration = data?.user || {};
  const organizationConfiguration = data?.organization || {};
  return {
    locale: userConfiguration.locale || organizationConfiguration.locale || defaultLocale,
    theme: userConfiguration.theme || organizationConfiguration.theme || getItem(THEME_KEY) || DEFAULT_THEME,
    timeZone:
      userConfiguration.timeZone ||
      organizationConfiguration.timeZone ||
      Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};

export const getModules = data => {
  if (MODULES) {
    return MODULES;
  }
  return data?.organization?.modules;
};
